import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  unreadCount: 0,
  items: [],
  isOpen: false,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    // Вызывается при WS push — вставляем в начало списка
    prependNotification: (state, action) => {
      state.unreadCount += 1;
      state.items = [action.payload, ...state.items];
    },
    markReadLocal: (state, action) => {
      const item = state.items.find((n) => n.id === action.payload);
      if (item && !item.is_read) {
        item.is_read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllReadLocal: (state) => {
      state.items.forEach((n) => { n.is_read = true; });
      state.unreadCount = 0;
    },
    removeLocal: (state, action) => {
      const item = state.items.find((n) => n.id === action.payload);
      if (item && !item.is_read) {
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
      state.items = state.items.filter((n) => n.id !== action.payload);
    },
    // Полная замена списка после загрузки из API
    setItems: (state, action) => {
      state.items = action.payload;
    },
    toggleOpen: (state) => {
      state.isOpen = !state.isOpen;
    },
    closePanel: (state) => {
      state.isOpen = false;
    },
  },
});

export const {
  setUnreadCount,
  prependNotification,
  markReadLocal,
  markAllReadLocal,
  removeLocal,
  setItems,
  toggleOpen,
  closePanel,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
